import React from "react";
import { Tooltip } from "antd";
import { LockOutlined } from "@ant-design/icons";

// Candado que se muestra junto a un campo bloqueado por falta de permiso.
// Al hacer clic abre el ModalAutorizacion para pedir una autorización rápida.
const BotonAutorizacion = ({ visible = true, onClick, titulo = "Solicitar autorización" }) => {
  if (!visible) return null;
  return (
    <Tooltip title={titulo}>
      <LockOutlined
        style={{ color: "#fa8c16", cursor: "pointer", marginLeft: 4 }}
        onClick={(e) => {
          e.stopPropagation();
          if (onClick) onClick();
        }}
      />
    </Tooltip>
  );
};

export default BotonAutorizacion;
